var _path, _path2, _path3, _path4;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgGoldenBook(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.3334 13.9501V3.89174C18.3334 2.89174 17.5167 2.15008 16.5251 2.23341H16.4751C14.7251 2.38341 12.0667 3.27508 10.5834 4.20841L10.4417 4.30008C10.2001 4.45008 9.80008 4.45008 9.55841 4.30008L9.35008 4.17508C7.86675 3.25008 5.21675 2.36674 3.46675 2.22508C2.47508 2.14174 1.66675 2.89174 1.66675 3.88341V13.9501C1.66675 14.7501 2.31675 15.5001 3.11675 15.6001L3.35841 15.6334C5.16675 15.8751 7.95841 16.7917 9.55841 17.6667L9.59175 17.6834C9.81675 17.8084 10.1751 17.8084 10.3917 17.6834C11.9917 16.8001 14.7917 15.8751 16.6084 15.6334L16.8834 15.6001C17.6834 15.5001 18.3334 14.7501 18.3334 13.9501Z",
    stroke: "#F6B21A",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10 4.5752V17.0752",
    stroke: "#F6B21A",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M6.45825 7.0752H4.58325",
    stroke: "#F6B21A",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M7.08325 9.5752H4.58325",
    stroke: "#F6B21A",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoldenBook);
export default __webpack_public_path__ + "static/media/golden-book.8b705619aaaa9ab7243b4b4f57190c9e.svg";
export { ForwardRef as ReactComponent };